"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const IconCheckModal_1 = __importDefault(require("../../assets/icons/IconCheckModal"));
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalSuccess = (props) => {
    const { visible, onClose, content, } = props;
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "none", statusBarTranslucent: true, transparent: true, onRequestClose: () => {
            onClose();
        }, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 1, style: styles.viewContain, onPress: () => {
                onClose();
            } },
            react_1.default.createElement(react_native_1.View, { style: styles.viewModal },
                react_1.default.createElement(IconCheckModal_1.default, null),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.textTitle1 }, content)))));
};
const styles = react_native_1.StyleSheet.create({
    btn: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    vBtn: {
        height: (0, scale_1.scale)(62),
        width: "100%",
        borderTopWidth: 1,
        borderTopColor: "#CCCCCC",
        flexDirection: "row",
    },
    textTitle: {
        marginTop: (0, scale_1.scale)(19),
        marginBottom: (0, scale_1.scale)(5),
        color: "#000000",
        fontSize: (0, scale_1.moderateScale)(25),
        lineHeight: (0, scale_1.moderateScale)(40),
    },
    textTitle1: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(22),
        textAlign: "center",
        marginLeft: (0, scale_1.scale)(12),
        flex: 1
    },
    viewModal: {
        backgroundColor: "#44A06B",
        width: (0, scale_1.scale)(343),
        alignItems: "center",
        borderRadius: (0, scale_1.scale)(99),
        height: (0, scale_1.scale)(37),
        flexDirection: "row",
        marginTop: (0, scale_1.scale)(60),
        paddingHorizontal: (0, scale_1.scale)(16),
    },
    viewContain: {
        flex: 1,
        alignItems: "center",
        paddingHorizontal: (0, scale_1.scale)(20),
    },
});
exports.default = ModalSuccess;
